import { FaCar } from "react-icons/fa";
import { GiVacuumCleaner } from "react-icons/gi";
import { PiSprayBottleBold } from "react-icons/pi";
import { GiCarSeat } from "react-icons/gi";
import { TfiDashboard } from "react-icons/tfi";
import { LuCupSoda } from "react-icons/lu";
import { GiSparkles } from "react-icons/gi";
import { BsSuitcaseLg } from "react-icons/bs";
import { FaAirFreshener } from "react-icons/fa";
import "./PackageInfo.css";
function Interior() {
  return (
    <div className="package-info">
      {/* all sections */}

      <>
        <section className="service-hero">
          <div className="service-content">
            <span className="service-tag">PREMIUM DETAILING SERVICE</span>

            <h1>Interior Detailing</h1>

            <p className="service-description">
              Give your vehicle’s interior a fresh start. Our interior detailing
              service removes built-up dirt, dust, stains, crumbs, pet hair, and
              everyday messes from the areas you use most.
            </p>
          </div>

          <div className="service-image">
            <img src="/images/IMG_1029.JPG" alt="Exterior Detailing" />
          </div>
        </section>

        <section className="service-cards">
          <div className="card">
            <div className="card-header">
              {/* Icon */}
              <FaCar color="#f703ff" />
              <h2>What's Included</h2>
            </div>

            <div className="two-column-list">
              <div>
                <div className="feature">
                  {/* Icon */}
                  <GiVacuumCleaner color="#f703ff" />
                  <span>Thorough vacuuming</span>
                </div>
                <div className="feature">
                  {/* Icon */}
                  <PiSprayBottleBold color="#f703ff" />
                  <span>Carpet and floor mat cleaning</span>
                </div>
                <div className="feature">
                  {/* Icon */}
                  <GiCarSeat color="#f703ff" />
                  <span>Seat cleaning</span>
                </div>

                <div className="feature">
                  {/* Icon */}
                  <TfiDashboard color="#f703ff" />
                  <span>Dashboard, console, and door-panel cleaning</span>
                </div>
                <div className="feature">
                  {/* Icon */}
                  <LuCupSoda color="#f703ff" />
                  <span>Cupholder and crevice cleaning</span>
                </div>
                <div className="feature">
                  {/* Icon */}
                  <GiSparkles color="#f703ff" />
                  <span>Interior window cleaning</span>
                </div>
                <div className="feature">
                  {/* Icon */}
                  <BsSuitcaseLg color="#f703ff" />
                  <span>Trunk or cargo-area cleaning</span>
                </div>
                <div className="feature">
                  {/* Icon */}
                  <FaAirFreshener color="#f703ff" />
                  <span>Odor treatment when needed</span>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    </div>
  );
}
export default Interior;
